import { GET_COUNTS } from './actions';
import { SET_COUNTS } from './mutations';
import HTTP from './../lib/HTTP';

const state = {
  data: null,
};

const mutations = {
  [SET_COUNTS](_state, feeds) {
    _state.data = feeds;
  },
};

const actions = {
  [GET_COUNTS](context) {
    return new Promise((resolve, reject) => {
      HTTP.get('counts').then((res) => {
        if (res && res.data) {
          context.commit(SET_COUNTS, res.data);
        }
        resolve(res);
      }).catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  },
};

export default {
  state,
  mutations,
  actions,
};
